export const USER_DETAILS = "USER_DETAILS";
export const PROXY_USER_DETAILS = "PROXY_USER_DETAILS";
export const CURRENT_COURSE_ID = "CURRENT_COURSE_ID";
export const CURRENT_LESSON_ID = "CURRENT_LESSON_ID";
export const ROLES = {
  ADMIN: "ADMIN",
  STAFF_FACULTY: "STAFF_FACULTY",
  ALUMNI: "ALUMNI",
  STUDENT: "STUDENT",
  PARENTS: "PARENTS",
};

export const STATUS_DATA = [
  { value: "publish", label: "Publish" },
  { value: "draft", label: "Draft" },
];

export const FONT_VALUE = [
  { value: "arial", label: "Arial" },
  { value: "bedrock", label: "Bedrock" },
  { value: "cosmic sans ms", label: "Cosmic Sans MS" },
  { value: "edwardian script", label: "Edwardian Script" },
  { value: "georgia", label: "Georgia" },
  { value: "impact", label: "Impact" },
  { value: "lucida console", label: "Lucida Console" },
  { value: "tahoma", label: "Tahoma" },
  { value: "Times New Roman", label: "Times New Roman" },
  { value: "Verdana", label: "Verdana" },
  { value: "WildWest", label: "WildWest" },
];

export const EMPTY_COURSE_OBJ = {
  name: "",
  campus: "",
  instructor: [],
  categories: "",
  prerequisite: [],
  terms: "",
  description: "",
  logo: "",
  noOfSeats: 0,
  sendApprovalEmail: "NO",
  approvalEmail: "",
  allowWaitList: "NO",
  sendWaitListEmail: "NO",
  waitListEmail: "",
  activeStatus: false,
  sortDiscussionBy: "Date",
  commentDeletion: "Fully Removed",
  courseType: "Course",
  certificatePrinting: "",
  certificateStyle: "",
  certificateCredit: "",
  certificateTypeExpiration: "",
  certificateTypeExpNumber: 0,
  startDate: "",
  endDate: "",
  courseLengthInDays: 0,
  mandatoryUserRole: [],
  keyword: "",
};

export const EMPTY_COMMUNITY_OBJ = {
  leader: [],
  category: "",
  preRequisite: [],
  name: "",
  customIdentifier: "",
  description: "",
  logo: "",
  private: false,
  communityPost: false,
  groupDiscussionPost: false,
  sortDiscussion: "",
  commentDeletion: "",
  leaderEnrollStudent: false,
  userType: [],
  mandatoryCampus: "",
  selectCampus: "",
  mandatoryTerm: "",
  selectTerms: "",
  activeStatus: false,
};
export const EMPTY_SURVEY_OBJ = {
  _id: "",
  course: "",
  options: [],
  optionLabels: [],
  order: "",
  question: "",
  status: "",
  survey: "",
  type: "",
};
export const CONTENT_TYPE = [
  { label: "Add File", value: "file" },
  // { label: "Add Audio File", value: "audio_file" },
  // { label: "Discussion Forum", value: "discussion_forum" },
  { label: "Discussion Post", value: "discussion_box" },
  { label: "File Upload", value: "dropbox" },
  { label: "File From Course Resources", value: "file_from_course_resources" },
  { label: "File From My Repository ", value: "file_from_my_reporitory" },
  // {
  //   label: "File From My Department Reporitory",
  //   value: "file_from_department_reporitory",
  // },
  {
    label: "File From Global Repository",
    value: "file_from_global_reporitory",
  },
  {
    label: "Folder From Course Resources",
    value: "folder_from_course_repository",
  },
  {
    label: "Google Map/Google Earth",
    value: "google_map",
  },
  {
    label: "Other External Embedded Code",
    value: "other_external_embeded_code",
  },
  // {
  //   label: "SCORM",
  //   value: "scorm",
  // },
  {
    label: "Survey",
    value: "survey",
  },
  {
    label: "Test",
    value: "test",
  },
  {
    label: "Text/HTML Block",
    value: "text_html_block",
  },
  // {
  //   label: "Wiki",
  //   value: "wiki",
  // },
  {
    label: "Youtube, Google or Other External Video Embed",
    value: "youtube_google_other_video",
  },
];
export const LESSON_CONTENT_OBJ = {
  discussion_forum: null,
  discussion_box: null,
  dropbox: null,
  resource_owner: null,
  resource_folder: null,
  resource_file: null,
  google_map: "",
  other_external_embeded_code: "",
  scorm: "",
  survey: null,
  test: null,
  text_html_block: "",
  wiki: "",
  youtube_google_other_video: "",
};

export const LESSON_CONTENT_TYPES = {
  FILE: "file",
  AUDIO_FILE: "audio_file",
  DISCUSSION_FORUM: "discussion_forum",
  DISCUSSION_POST: "discussion_box",
  DROPBOX: "dropbox",
  FILE_FROM_COURSE_RES: "file_from_course_resources",
  FILE_FROM_MY_REPO: "file_from_my_reporitory",
  FILE_FROM_GLOBAL_REPO: "file_from_global_reporitory",
  FOLDER_FROM_COURSE_REPO: "folder_from_course_repository",
  GOOGLE_MAP: "google_map",
  OTHER_EXT_EMB_CODE: "other_external_embeded_code",
  SCORM: "scorm",
  SURVEY: "survey",
  TEST: "test",
  TEXT_HTML_BLOCK: "text_html_block",
  // WIKI: "wiki",
  YOUTUBE_GOOGLE_VIDEO: "youtube_google_other_video",
};

export const LESSON_CONTENT_REQUIRED_OBJECT = {
  [LESSON_CONTENT_TYPES.DISCUSSION_FORUM]: ["discussion_forum"],
  [LESSON_CONTENT_TYPES.DISCUSSION_POST]: ["discussion_box"],
  [LESSON_CONTENT_TYPES.DROPBOX]: ["dropbox"],
  [LESSON_CONTENT_TYPES.SURVEY]: ["survey"],
  [LESSON_CONTENT_TYPES.TEST]: ["test"],
  [LESSON_CONTENT_TYPES.GOOGLE_MAP]: ["google_map"],
  [LESSON_CONTENT_TYPES.TEXT_HTML_BLOCK]: ["text_html_block"],
  [LESSON_CONTENT_TYPES.OTHER_EXT_EMB_CODE]: ["other_external_embeded_code"],
  [LESSON_CONTENT_TYPES.YOUTUBE_GOOGLE_VIDEO]: ["youtube_google_other_video"],
  [LESSON_CONTENT_TYPES.FILE_FROM_COURSE_RES]: [
    "resource_owner",
    "resource_folder",
    "resource_file",
  ],
  [LESSON_CONTENT_TYPES.FILE_FROM_GLOBAL_REPO]: [
    "resource_owner",
    "resource_folder",
    "resource_file",
  ],
  [LESSON_CONTENT_TYPES.FILE_FROM_MY_REPO]: [
    "resource_owner",
    "resource_folder",
    "resource_file",
  ],
  [LESSON_CONTENT_TYPES.FOLDER_FROM_COURSE_REPO]: [
    "resource_owner",
    "resource_folder",
  ],
  [LESSON_CONTENT_TYPES.WIKI]: [],
  [LESSON_CONTENT_TYPES.SCORM]: [],
  [LESSON_CONTENT_TYPES.FILE]: [],
  [LESSON_CONTENT_TYPES.AUDIO_FILE]: [],
  required: ["name", "lesson", "instruction", "contentType", "status", "order"],
};

export const EMPTY_LESSON_CONTENT = {
  name: "",
  lesson: "",
  instruction: "",
  contentType: "",
  status: "publish",
  order: 0,
  ...LESSON_CONTENT_OBJ,
};

export const EMPTY_EMAIL_CONTENT = {
  recipients: "",
  externalRecipients: [],
  cc: [],
  bcc: [],
  html: "",
  replyTo: "",
  altText: "",
  subject: "",
  mailBody: "",
  attachments: [{}],
};
